
<template>
    <ModalTitle
        :model-value="modelValue"
        :backdrop="backdrop"
        :drawer="true"
        container-class="game-rules-modal-container"
        @update:model-value="onModelValue"
    >
    <template #header>
            <span class="text-[24px] leading-10">
                {{ `${$t('jisuzhajinhua.basicRules')}` }}
            </span>
        </template>
        <!-- 主要内容区域 -->
        <div class="main-content">
            <!-- 规则内容 -->
            <div class="rules-content">
                <div class="rules-list">
                    <div class="rule-item">
                        <div class="rule-icon">
                            <IconSvgUse use="icon-spade" size="16px"/>
                        </div>
                        <span class="rule-text">
                            {{ $t('jisuzhajinhua.rule1') }}
                        </span>
                    </div>
                    
                    <div class="rule-item">
                        <div class="rule-icon">
                            <IconSvgUse use="icon-spade" size="16px"/>
                        </div>
                        <span class="rule-text">
                            {{ $t('jisuzhajinhua.rule2') }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- 底部按钮 -->
        <div class="bottom-button">
            <ButtonThe3DButton
                color="red"
                size="lg"
                full-width
                @click="onStartGame"
            >
                {{ $t('jisuzhajinhua.startGame') }}
            </ButtonThe3DButton>
        </div>
    </ModalTitle>
</template>

<script lang="ts" setup>
const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false
    },
    currentRound: {
        type: Number,
        default: 0
    },
    backdrop: {
        type: Boolean,
        default: true
    }
});

const emit = defineEmits(['update:modelValue', 'startGame']);

const onModelValue = (value: boolean) => {
    emit('update:modelValue', value);
};

const onBackdrop = () => {
    if (props.backdrop) {
        emit('update:modelValue', false);
    }
};

const onStartGame = () => {
    emit('startGame');
    emit('update:modelValue', false);
};
</script>

<style lang="scss" scoped>
// 使用Modal组件的drawer模式，样式会继承Modal的基础样式
.game-rules-modal-container {
    // background: #111923;
    border-radius: 16px 16px 0 0;
    max-height: 90vh;
    overflow-y: auto;
    position: relative;
    
    // 添加标准的modal header渐变背景
    &::before {
        background: linear-gradient(180deg, #003370, transparent);
    border-radius: 14px 14px 0 0;
    content: '';
    display: block;
    height: 72px;
    left: 0;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 0;
    }
}

.close-btn {
    position: absolute;
    top: 16px;
    right: 16px;
    background: transparent;
    border: none;
    color: #93acd3;
    cursor: pointer;
    padding: 8px;
    border-radius: 8px;
    transition: all 0.2s ease;
    z-index: 10;
    
    &:hover {
        background: rgba(255, 255, 255, 0.1);
        color: white;
    }
}

.main-content {
    padding: 32px 24px 24px 24px;
    // background: #111923;
    position: relative;
    min-height: 200px;
    z-index: 1;
}

.rules-content {
    position: relative;
    
    .rules-title {
        color: white;
        font-size: 24px;
        font-weight: 700;
        margin: 0 0 24px 0;
        text-align: left;
    }
    
    .rules-list {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }
    
    .rule-item {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        
        .rule-icon {
            color: #60a5fa;
            margin-top: 2px;
            flex-shrink: 0;
        }
        
        .rule-text {
            color: white;
            font-size: 16px;
            line-height: 1.6;
            flex: 1;
            
            // 高亮数字
            :deep(strong) {
                color: white;
                font-weight: 700;
            }
        }
    }
}

.bottom-button {
    z-index: 1;
    position: relative;
}

// 移动端适配
@media (max-width: 768px) {
    .main-content {
        padding: 24px 20px 20px 20px;
    }
    
    .rules-content {
        .rules-title {
            font-size: 20px;
        }
        
        .rule-item {
            .rule-text {
                font-size: 14px;
            }
        }
    }
    
    .bottom-button {
        padding: 20px;
    }
}
</style>
